import React from 'react'

import style from './CategoriesSearch.module.css'

import { Search } from 'common/components'
import { useAppDispatch, useAppSelector } from 'common/hooks'
import { selectSearchText, setSearch } from 'features/dashboard'

export const CategoriesSearch = () => {
  const dispatch = useAppDispatch()
  const searchText = useAppSelector(selectSearchText)

  const searchHandler = (searchText: string) => {
    dispatch(setSearch(searchText))
  }

  const clearButtonHandler = () => {
    dispatch(setSearch(''))
  }

  return (
    <Search
      className={style.search}
      placeholder="Поиск по тренировкам"
      onChangeText={searchHandler}
      clearButtonHandler={clearButtonHandler}
      value={searchText}
    />
  )
}
